import { formatDate } from '@/lib/date'
import { getFullName } from '@/lib/user'
import { getRevLink } from '@/lib/rev'
import common from './common'
import i18next from 'i18next'

export default {
  ...common,
  owner: item => getFullName(item?.owner),
  coach: item => getFullName(item?.coach),
  collaborators: item =>
    item?.collaborators
      ?.map(collaborator => getFullName(collaborator))
      .join(', ') ?? '',
  impactStartDate: item => formatDate(item?.impactStartsAt),
  impactEndDate: item => formatDate(item?.impactEndsAt),
  financialValidationDate: item =>
    formatDate(item?.validations?.financial?.validatedAt),
  totalImpactAmount: item => item?.validatedReview?.totalImpact ?? '',
  implemented: item =>
    item?.validations?.implementation?.isValidated
      ? i18next.t('column_selector.implemented')
      : i18next.t('common.not_implemented'),
  impactValidated: item =>
    item?.validations?.financial?.isValidated
      ? i18next.t('common.validated_impact')
      : i18next.t('common.impact_not_validated'),
  link: item => getRevLink(item),
}
